const strReplace = (htmlString) => {
  return htmlString.replace(/&amp;/g, "&");
};

const amountFormatter = (amount) => {
  let dollars = "0";
  let cents = " 00";
  if (!isNaN(amount)) {
    amount = amount.toString().split(".");
    dollars = amount[0];
    cents = amount[1]
      ? amount[1].length < 2
        ? amount[1] + "0"
        : amount[1].substring(0, 2)
      : "00";
    dollars = parseInt(dollars).toLocaleString();
    dollars = dollars.toString();
  }
  return {
    dollars,
    cents,
  };
};

const convertTens = (num) => {
  if (!isNaN(num)) {
    num = parseInt(num);
    num = num / 100;
    num = num.toFixed(2);
    num = num.split(".")[1];
  }
  return num;
};

const numberFormat = (number) => {
  return Math.round(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const highlightText = (searchText, searchIn) => {
  const regex = RegExp(searchText, "gi"); // case insensitive
  const replacement = "<b>" + searchText + "</b>";
  const highlightedText = searchIn.replace(regex, replacement);
  return highlightedText;
};

const customerServiceNumberFormatted = '1-877-760-0075';
const customerServiceNumber = '18777600075';

export {
  amountFormatter,
  convertTens,
  strReplace,
  customerServiceNumberFormatted,
  customerServiceNumber,
  numberFormat,
  highlightText,
};
